import React from 'react';
import image3D from '../assets/2year.png'; // ✅ Check image path

const TwoYearProgram = () => {
  return (
    <div
      style={{
        padding: '40px',
        fontFamily: 'sans-serif',
        background: 'white',
        minHeight: '100vh',
      }}
    >
      {/* Heading + Image Row */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '20px',
        }}
      >
        {/* Left Section: Heading + Subheading + Small Container */}
        <div style={{ flex: '1', minWidth: '280px', marginLeft: '70px' }}>
          <h1 style={{ marginBottom: '10px', color: '#111', fontSize: '40px' }}>
          2-Year AI-Ready Tech Program
          </h1>
          <p style={{ fontSize: '22px', color: '#111', marginBottom: '20px' }}>
          Future-Ready Skills + AI Mastery + Job Guarantee
          </p>

          {/* Program Overview Container */}
          <div
            style={{
              padding: '25px',
              background: '#F9CF00',
              borderRadius: '12px',
              boxShadow: '0 6px 30px rgba(8, 127, 255, 0.15)',
              maxWidth: '340px',
              marginTop: '10px',
              transition: 'all 0.4s ease',
              cursor: 'pointer',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 10px 40px rgba(0, 123, 255, 0.35)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 6px 30px rgba(0, 123, 255, 0.15)';
            }}
          >
            <h2 style={{ marginBottom: '10px', color: '#111', fontSize: '20px' }}>
              Program Overview
            </h2>
            <p style={{ color: '#111', fontSize: '15px' }}>
            A revolutionary 2-year program designed to make you job-ready with cutting-edge AI skills, full-stack development, and industry experience. Master GenAI, LLMs, Cloud computing, and DSA while working on real-world projects. 95% job placement guarantee!</p>
          </div>
        </div>

        {/* Right Section: Image */}
        <div style={{ flex: '0 0 500px', textAlign: 'center', marginLeft: '-10px' }}>
          <img
            src={image3D}
            alt="3D Professor"
            style={{
              width: '100%',
              maxWidth: '400px',
              height: '500px',
              objectFit: 'contain',
            }}
          />
        </div>
      </div>

      {/* Monthly Training Breakdown Heading */}
      <h2
        style={{
          marginTop: '50px',
          textAlign: 'center',
          color: '#111',
          fontSize: '26px',
        }}
      >
        Monthly Training Breakdown
      </h2>

      {/* Container for Monthly Breakdown */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '20px',
          flexWrap: 'wrap',
          marginTop: '30px',
        }}
      >
        {/* First Container */}
        <div
          style={{
            flex: '1',
            maxWidth: '300px',
            height: '350px', // Same height for all containers
            padding: '20px',
            background: '#D9D9D9',
            borderRadius: '12px',
            boxShadow: '0 6px 20px rgba(0, 123, 255, 0.15)',
            transition: 'all 0.3s ease',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 123, 255, 0.25)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 123, 255, 0.15)';
          }}
        >
          <h3 style={{ marginBottom: '10px', color: '#111', fontSize: '18px' }}>Year 1: Foundation + DSA</h3>
          <h4 style={{ fontSize: '16px', color: '#333' }}>Job-Ready Fundamentals with Problem-Solving</h4>
          <ul style={{ color: '#111', fontSize: '14px' }}>
            <li>Months 1-3: Programming Fundamentals + DSA Basics</li>
            <li>Months 4-6: Full-Stack Development (MERN/MEAN)</li>
            <li>Months 7-9: Advanced DSA + System Design + Projects</li>
            <li>Months 10-12: Interview Prep + Internship Placement</li>
          </ul>
        </div>

        {/* Second Container */}
        <div
          style={{
            flex: '1',
            maxWidth: '300px',
            height: '350px', // Same height for all containers
            padding: '20px',
            background: '#D9D9D9',
            borderRadius: '12px',
            boxShadow: '0 6px 20px rgba(255, 105, 180, 0.15)',
            transition: 'all 0.3s ease',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 10px 30px rgba(255, 105, 180, 0.25)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(255, 105, 180, 0.15)';
          }}
        >
          <h3 style={{ marginBottom: '10px', color: '#111', fontSize: '18px' }}>Months 13-18: AI & Advanced Tech Mastery</h3>
          <h4 style={{ fontSize: '16px', color: '#333' }}>Become an AI-powered developer that companies need</h4>
          <ul style={{ color: '#111', fontSize: '14px' }}>
            <li>GenAI & LLMs: ChatGPT API, RAG, Vector Databases</li>
            <li>Machine Learning: TensorFlow, PyTorch, Computer Vision</li>
            <li>Cloud & DevOps: AWS/Azure, Docker, Kubernetes, CI/CD</li>
            <li>AI-Powered Full-Stack: Building intelligent web applications</li>
          </ul>
        </div>

        {/* Third Container */}
        <div
          style={{
            flex: '1',
            maxWidth: '300px',
            height: '350px', // Same height for all containers
            padding: '20px',
            background: '#D9D9D9',
            borderRadius: '12px',
            boxShadow: '0 6px 20px rgba(255, 193, 7, 0.15)',
            transition: 'all 0.3s ease',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 10px 30px rgba(255, 193, 7, 0.25)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(255, 193, 7, 0.15)';
          }}
        >
          <h3 style={{ marginBottom: '10px', color: '#111', fontSize: '18px' }}>Months 19-24: Industry Experience & Job Placement</h3>
          <h4 style={{ fontSize: '16px', color: '#333' }}>Real companies, real projects, guaranteed placement</h4>
          <ul style={{ color: '#111', fontSize: '14px' }}>
            <li>6-month paid internship with partner companies</li>
            <li>Build production-grade AI applications</li>
            <li>Advanced interview preparation (Technical + Behavioral)</li>
            <li>Portfolio development & LinkedIn optimization</li>
            <li>Job placement assistance with 95% success rate</li>
          </ul>
        </div>
      </div>

      {/* Heading for the 6 Sections */}
<h2 style={{ textAlign: 'center', fontSize: '26px', color: '#222', marginTop: '60px' }}>
  Why Our Program Stands Out in the AI Era
</h2>

{/* Competitive Advantages Section */}
<div style={{
  display: 'flex',
  justifyContent: 'center',
  gap: '20px',
  flexWrap: 'wrap',
  marginTop: '30px',
  marginBottom: '40px',
}}>
  {[
    {
      title: '🤖 AI-First Approach',
      desc: 'Learn to build with ChatGPT API, create RAG systems, and develop intelligent applications that companies desperately need.',
      bg: '#E8F5E8'
    },
    {
      title: '💪 DSA Mastery',
      desc: 'Complete Data Structures & Algorithms preparation with 500+ problems solved. Crack any tech interview confidently.',
      bg: '#E8F0FF'
    },
    {
      title: '💼 Guaranteed Income',
      desc: 'Paid internship in month 13-18 (₹15K-25K/month) + Job placement guarantee with 95% success rate.',
      bg: '#FFF5E6'
    }
  ].map((item, index) => (
    <div key={index} style={{
      flex: '1',
      maxWidth: '300px',
      padding: '25px',
      background: item.bg,
      borderRadius: '15px',
      boxShadow: '0 8px 25px rgba(0, 0, 0, 0.1)',
      textAlign: 'center',
      transition: 'transform 0.3s ease',
    }}>
      <h3 style={{ fontSize: '18px', color: '#111', marginBottom: '15px' }}>{item.title}</h3>
      <p style={{ fontSize: '14px', color: '#333', lineHeight: '1.6' }}>{item.desc}</p>
    </div>
  ))}
</div>

<h2 style={{ textAlign: 'center', fontSize: '26px', color: '#222', marginTop: '40px' }}>
  Program Details
</h2>

            {/* 6 Sections Below - Key Features or Additional Modules */}
            <div
  style={{
    marginTop: '60px',
    maxWidth: '1000px',
    margin: 'auto',
    backgroundColor: '#fff',
    padding: '30px',
    fontFamily: 'sans-serif',
  }}
>
  {[
    [
      {
        title: '💰 Investment & ROI',
        desc: [
          'Total Investment: ₹12,000/- only (includes everything)',
          'Payment Options: ₹15,000/- (Two installments)',
          'Expected Salary: ₹4-8 LPA after completion',
          'ROI: 4000%+ return on your investment',
          'Note: Includes paid internship opportunity worth ₹90K+',
        ],
      },
      {
        title: '✅ Eligibility Criteria',
        desc: [
          'College Student (Any Stream) or Recent Graduate',
          'Basic understanding of any programming language',
          'Willing to dedicate 4-6 hours daily for learning',
          'Has a good laptop (8GB RAM minimum) and stable internet',
          'Serious about building a tech career in AI era',
          'Ready to commit to 2-year intensive program',
        ],
      },
    ],
    [
      {
        title: '📜 Rules & Guidelines',
        desc: [
          'Complete weekly tasks to stay active.',
          'Irregular or inactive participants may be removed.',
          'Respect all mentors and fellow learners.',
          'Group projects will require team collaboration.',
          'Internship Certificates will be given only after project submission.',
        ],
      },
      {
        title: '🎁 What You Get',
        desc: [
          '2-Year AI-Focused Training Program',
          'Complete DSA & Interview Preparation',
          'GenAI & LLM Development Skills',
          '6-month Paid Internship Guarantee',
          '95% Job Placement Success Rate',
          'Industry-Ready Project Portfolio',
          '24/7 Mentor Support & Career Guidance',
        ],
      },
    ],
    [
      {
        title: '📌 Why Choose This Program?',
        desc: [
          'Only program offering GenAI + Full-Stack + DSA together',
          'Learn trending technologies: ChatGPT API, RAG, Vector DBs',
          'Paid internship opportunity (₹15,000-25,000/month)',
          'Job guarantee with top tech companies',
          '50+ real-world AI projects in portfolio',
          'Future-proof skills for the AI era',
        ],
      },
      {
        title: '📞 Get in Touch',
        desc: [
          '📧 Email: admin@willovate.in',
          '📱 WhatsApp: +91-9356603646',
        ],
      },
    ],
  ].map((row, rowIndex) => (
    <div key={rowIndex} style={{ marginBottom: '30px' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: '40px',
          position: 'relative',
        }}
      >
        {row.map((item, i) => (
          <div key={i} style={{ flex: '1', padding: '10px', textAlign: 'center' }}>
            <h3 style={{ fontSize: '22px', color: '#111', marginBottom: '12px' }}>{item.title}</h3>
            <ul style={{ listStyleType: 'disc', marginLeft: '20px', color: '#444', padding: '0', textAlign: 'left' }}>
              {item.desc.map((point, index) => (
                <li key={index} style={{ marginBottom: '8px', fontSize: '16px' }}>{point}</li>
              ))}
            </ul>
          </div>
        ))}
        {/* Vertical Line Between Boxes */}
        <div style={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: '50%',
          width: '1px',
          backgroundColor: '#ccc',
          transform: 'translateX(-50%)',
        }} />
      </div>
      {/* Horizontal line below each row */}
      {rowIndex < 2 && (
        <hr
          style={{
            marginTop: '30px',
            border: 'none',
            borderTop: '1px solid #ccc',
          }}
        />
      )}
    </div>
  ))}
</div>

      {/* Closing Note or Call to Action */}
      <div style={{ marginTop: '60px', textAlign: 'center' }}>
  <h2 style={{ fontSize: '28px', color: '#111', marginBottom: '10px' }}>
    Don't Get Left Behind in the AI Revolution!
  </h2>
  <p style={{ fontSize: '18px', color: '#666', marginBottom: '25px', maxWidth: '600px', margin: '0 auto 25px' }}>
    While others struggle with outdated skills, you'll be building AI-powered applications and earning ₹4-8 LPA. Limited seats available!
  </p>
  <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
    <button
    style={{
      padding: '15px 30px',
      fontSize: '18px',
      backgroundColor: '#F19F4D',
      color: '#fff',
      border: 'none',
      borderRadius: '10px',
      cursor: 'pointer',
      boxShadow: '0 6px 20px rgba(241, 159, 77, 0.4)',
      transition: 'all 0.3s ease',
      fontWeight: 'bold',
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.backgroundColor = '#d9883b';
      e.currentTarget.style.transform = 'translateY(-2px)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.backgroundColor = '#F19F4D';
      e.currentTarget.style.transform = 'translateY(0)';
    }}
    onClick={() => {
      window.open('https://forms.gle/VZfbRCurJkDGXdx7A', '_blank');
    }}
  >
    🚀 Secure Your Spot Now
  </button>
  <button
    style={{
      padding: '15px 30px',
      fontSize: '18px',
      backgroundColor: 'transparent',
      color: '#F19F4D',
      border: '2px solid #F19F4D',
      borderRadius: '10px',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      fontWeight: 'bold',
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.backgroundColor = '#F19F4D';
      e.currentTarget.style.color = '#fff';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.backgroundColor = 'transparent';
      e.currentTarget.style.color = '#F19F4D';
    }}
    onClick={() => {
      window.open('https://wa.me/919356603646?text=I want to know more about the 2-Year AI-Ready Tech Program', '_blank');
    }}
  >
    💬 Chat with Mentor
  </button>
  </div>
  <p style={{ fontSize: '14px', color: '#999', marginTop: '15px' }}>
    ⏰ Only 50 seats available this batch | 🎯 Next batch starts in 2 weeks
  </p>
</div>

    </div>
  );
};

export default TwoYearProgram;
